import { useQuery } from "react-query";
import { getPolicyTerms } from "../../../actions/Utilities/Policy";
import { useState } from "react";

export const useGetPolicyTerms = (deactivated = false) => {
  const [policyTerms, setPolicyTerms] = useState([]);
  useQuery("PolicyTerm", getPolicyTerms, {
    refetchOnWindowFocus: false,
    onSuccess: (res) => {
      const activeTerm = res.filter((pt) => pt.isActive === true);
      deactivated === true
        ? setPolicyTerms(
            activeTerm.map((data) => {
              return {
                label: data.policyTermName,
                value: data.polTerm,
              };
            })
          )
        : setPolicyTerms(res);
    },
  });
  return { policyTerms };
};
